module.exports = __webpack_public_path__ + "70f7cf615b04c5d053e91a4ab3dab207.svg";